import { requestApi } from './Api';

export const getHealthcareProgramConfig = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/get',
    params
  });

export const getCheckinHealthcareProgramConfig = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/patient/checkin/payment/healthcare_program',
    params
  });

export const updateHealthcareProgramConfig = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/update',
    params
  });

export const acceptHealthcareProgramTerms = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/accept_terms',
    params
  });

export const getFeatureWaitlist = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/wait_list/get',
    params
  });

export const joinFeatureWaitlist = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/wait_list/join',
    params
  });

export const leaveFeatureWaitlist = async (navigate, params) =>
  requestApi({
    navigate,
    method: 'post',
    url: '/api/practice/healthcare_program/wait_list/leave',
    params
  });
